module.exports = __webpack_public_path__ + "static/astral-1e216f5690535a322c18de0a6fd85121.gif";